import { Card, Grid, Button, CircularProgress, Box } from "@mui/material";
import { Send } from "@mui/icons-material";
import { FormSelect } from "./form-elements/FormSelect";
import { GeneralInquiryForm } from "./form-types/GeneralInquiryForm";
import { IncorrectInfoForm } from "./form-types/IncorrectInfoForm";
import { NewListingForm } from "./form-types/NewListingForm";

export const ContactForm = ({
  onSubmit,
  formData,
  handleChange,
  loading,
  setFormData,
  entries,
  handleEntryChange,
  handleImageUpload,
  removeImage,
  addNewEntry,
  removeEntry,
  generalMessage,
  handleGeneralMessageChange,
}) => {
  const renderForm = () => {
    switch (formData.type) {
      case "general":
        return (
          <GeneralInquiryForm formData={formData} handleChange={handleChange} />
        );
      case "correction":
        return (
          <IncorrectInfoForm
            formData={formData}
            handleChange={handleChange}
            setFormData={setFormData}
            entries={entries}
            handleEntryChange={handleEntryChange}
            handleImageUpload={handleImageUpload}
            removeImage={removeImage}
            addNewEntry={addNewEntry}
            removeEntry={removeEntry}
            generalMessage={generalMessage}
            handleGeneralMessageChange={handleGeneralMessageChange}
          />
        );
      case "addition":
        return (
          <NewListingForm
            formData={formData}
            handleChange={handleChange}
            setFormData={setFormData}
            entries={entries}
            handleEntryChange={handleEntryChange}
            handleImageUpload={handleImageUpload}
            removeImage={removeImage}
            addNewEntry={addNewEntry}
            removeEntry={removeEntry}
            generalMessage={generalMessage}
            handleGeneralMessageChange={handleGeneralMessageChange}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 800,
        mx: "auto",
        mt: 6,
        px: 2,
      }}
    >
      <Card
        sx={{
          p: { xs: 3, md: 5 },
          borderRadius: 4,
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.06)",
          backgroundColor: "#fff",
        }}
      >
        <form onSubmit={onSubmit}>
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <FormSelect
                label="Purpose of Contact"
                name="type"
                value={formData.type}
                onChange={handleChange}
                options={[
                  { value: "general", label: "General Inquiry" },
                  {
                    value: "correction",
                    label: "Report Incorrect Information",
                  },
                  { value: "addition", label: "Suggest New Listing" },
                ]}
                required
              />
            </Grid>

            <Grid item xs={12}>
              {renderForm()}
            </Grid>

            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                fullWidth
                size="large"
                disabled={loading}
                startIcon={!loading && <Send />}
                sx={{
                  borderRadius: 3,
                  padding: "10px 20px",
                  fontWeight: 600,
                  textTransform: "none",
                  fontSize: "1rem",
                  backgroundColor: "#00171f",
                  "&:hover": {
                    backgroundColor: "#00334e",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                  },
                }}
              >
                {loading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Submit"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </Card>
    </Box>
  );
};
